import routeService from '../../services/route_service.js';
import PostoperatorioService from '../../services/postoperatorio_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import DatosParametricosService from '../../services/datos_parametricos_service.js';
import InternacionService from '../../services/internacion_service.js';
import PacienteService from '../../services/paciente_service.js';
import Grid from '../../components/Grid';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const datosParametricosService = new DatosParametricosService();
const postoperatorioService = new PostoperatorioService();
const internacionService = new InternacionService();
const pacienteService = new PacienteService();


let _this;
export default {
	name: 'Postoperatorio',
	components: { Grid },
	data: function() {
		return {
			titulo: 'POSTOPERATORIO',
			internacion: {},
			modificando: false,
			data: {},
			complicacionesGuardadas: [],
			searchComplicaciones: true,
			generalService: generalService,
			pacienteInternacion: {},
			diagnosticos:[],
			condicionesAlta: [],
			complicaciones: [],
			tipoComplicaciones: [],
			validaciones: {},
			loginService: loginService,
			submited: false,
			obrasSociales: {},
			actions: [{
				icon: 'pencil',
				name: 'Editar',
				actionBtn: this.editar,
				buttonClass: 'btn btn-xs btn-secondary',
				hide: function() { return true }
			},{
				icon: 'x',
				name: 'Desactivar',
				actionBtn: this.desactivar,
				buttonClass: 'btn btn-xs btn-danger',
				hide: function() { return true }
			}],
			columns: [
				{key: 'idPostoperatorio', value: 'Id'},
				{key: 'fechaAltaPostoperatorioEs', value: 'Fecha'},
				{key: 'tipoComplicacionPostoperatorio', value: 'Tipo de complicacion'},
				{key: 'complicacionPostoperatorio', value: 'Complicacion'},
				{key: 'detalleTratExtraPostoperatorio', value: 'Detalle tratamiento extra'},
				/*{key: 'idPrimerAyudanteCirugia', value: 'Id Primer Ayudante Cirugia'},
				{key: 'idSegundoAyudanteCirugia', value: 'Id Segundo Ayudante Cirugia'},
				{key: 'complicacionesCirugia', value: 'Complicaciones Cirugia'},
				{key: 'col1Cirugia', value: 'Col1 Cirugia'},
				{key: 'col2Cirugia', value: 'Col2 Cirugia'},
				{key: 'col3Cirugia', value: 'Col3 Cirugia'},*/
			] 
		} 
	}, 
	created: function () {
		_this = this;
		routeService.destacarMenuItem("internaciones");
		this.submited = false;
		_this = this;
		this.getDiagnosticos();
		this.getCondicionesAlta();
		this.getInternacion();
		this.getComplicacionesPop();
		this.getTipoComplicaciones();
	}, 
	methods: { 
		getInternacion() {
			if(routeService.getParams().id != undefined || routeService.getParams().idInternacion != undefined) {
				let searchInternacion = {idInternacion: routeService.getParams().id};
				internacionService.get(searchInternacion).then(function(response) {
					if(response.body == null) {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
						return;
					}
					if(response.body.length > 0) {
						for (let value of response.body) {
							_this.internacion = {
								idInternacion: value.idInternacion,
								idPacienteInternacion: value.idPacienteInternacion,
								tipoInternacion: value.tipoInternacion,
								ambulatorioInternacion: value.ambulatorioInternacion == 1 ? 'SI' : 'NO',
								camaInternacion: value.camaInternacion,
								diagnosticoInternacion: value.diagnosticoInternacion,
								idReInternacion: value.idReInternacion,
								idUserAnteriorInternacion: value.idUserAnteriorInternacion,
								pacienteInternacion: pacienteService.formatPaciente(value.pacienteInternacion),
								nomyApPaciente: value.pacienteInternacion.nombrePaciente + " " + value.pacienteInternacion.apellidoPaciente,
								dniPaciente: value.pacienteInternacion.dniPaciente,
								edadPaciente: value.pacienteInternacion.edadPaciente,
								nroHcPaciente: value.pacienteInternacion.nroHcPaciente,
								obraSocialPaciente: value.pacienteInternacion.obraSocialPaciente.nombreObraSocial,
								sexoPaciente: value.pacienteInternacion.sexoPaciente == 1 ? 'M' : 'F',
								idUserInternacion: value.idUserInternacion,
								idStaffInternacion: value.idStaffInternacion,
								nombreStaffInternacion: value.nombreStaffInternacion,
								idEspecialidadInternacion: value.idEspecialidadInternacion,
								especialidadInternacion: value.especialidadInternacion,
								alta: value.altaInternacion && value.idAltaInternacion ? 'SI' : 'NO',
								fechaAltaInternacion: value.altaInternacion && value.altaInternacion.fechaAltaInternacion ?  generalService.fechaSpanish(value.altaInternacion.fechaAltaInternacion) : '',
								activoInternacion: value.activoInternacion == 1 ? 'SI' : 'NO',
								col1Internacion: value.col1Internacion,
								col2Internacion: value.col2Internacion,
								col3Internacion: value.col3Internacion,
							}; 
							_this.titulo = 'POSTOPERATORIO DE ' + pacienteService.datosPersonalesPaciente(value.pacienteInternacion).toUpperCase();
							_this.getData();
						} 
					} 
				}, function(error) { 
					_this.submited = false;
					generalService.showRequestErrors(error, _this.$bvModal);
					return;
				});
				this.getData();
			} else {
				_this.cancelar();
			}
		},
		getData: function() {
			_this.submited = true;
			if(_this.internacion != undefined && _this.internacion.idInternacion != undefined && _this.internacion.idInternacion > 0) {
				_this.data.idInternacionPostoperatorio = _this.internacion.idInternacion;
				postoperatorioService.get({idInternacionPostoperatorio: _this.data.idInternacionPostoperatorio, orderBy: "fecha_postoperatorio desc"}).then(function(response) {
					_this.submited = false;
					_this.modificando = false;
					if(response.body == null) {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
						return;
					}
					_this.complicacionesGuardadas = [];
					if(response.body.length > 0) {
						for (let value of response.body) {
							/*_this.data = {
								idPostoperatorio: value.idPostoperatorio,
								idComplicacionPostoperatorio: value.idComplicacionPostoperatorio,
								fechaAltaPostoperatorio: value.fechaAltaPostoperatorio.substring(0,10),
								idInternacionPostoperatorio: value.idInternacionPostoperatorio,
								tratamientoExtraPostoperatorio: value.tratamientoExtraPostoperatorio,
								complicacionesPostoperatorio: [],
								detalleTratExtraPostoperatorio: value.detalleTratExtraPostoperatorio,
								col1Postoperatorio: value.col1Postoperatorio,
								col2Postoperatorio: value.col2Postoperatorio,
								col3Postoperatorio: value.col3Postoperatorio,
							};*/
							_this.complicacionesGuardadas.push({
								idPostoperatorio: value.idPostoperatorio,
								idComplicacionPostoperatorio: value.idComplicacionPostoperatorio,
								idTipoComplicacionPostoperatorio: value.tipoComplicacionPostoperatorio == "" ? "" : value.tipoComplicacionPostoperatorio.idDatoParametrico,
								tipoComplicacionPostoperatorio: value.tipoComplicacionPostoperatorio == "" ? "" : value.tipoComplicacionPostoperatorio.descripcionDatoParametrico,
								complicacionPostoperatorio: value.complicacionPostoperatorio.descripcionDatoParametrico,
								fechaAltaPostoperatorio: value.fechaAltaPostoperatorio.substring(0,10),
								fechaAltaPostoperatorioEs: generalService.fechaSpanish(value.fechaAltaPostoperatorio.substring(0,10)),
								idInternacionPostoperatorio: value.idInternacionPostoperatorio,
								tratamientoExtraPostoperatorio: value.tratamientoExtraPostoperatorio,
								complicacionesPostoperatorio: [],
								detalleTratExtraPostoperatorio: value.detalleTratExtraPostoperatorio,
								col1Postoperatorio: value.col1Postoperatorio,
								col2Postoperatorio: value.col2Postoperatorio,
								col3Postoperatorio: value.col3Postoperatorio,
							});
						} 
						//_this.getComplicacionesPostoperatorio();
					} 
					_this.data.pacienteInternacion = internacionService.formatInternacion(_this.internacion);
				}, function(error) { 
					_this.modificando = false;
					_this.submited = false;
					generalService.showRequestErrors(error, _this.$bvModal);
					return;
				});
			} else {
				_this.modificando = false;
				if(!loginService.hasPermission("activar", "alta_internacion")) {
					routeService.goToHome();
					return;
				}
			}
		},
		save: function() {
			let errores = this.validar();
			if (errores) {
				/*let errores = "";
				for(const prop in validaciones) {
					for(const error of validaciones[prop].errores) {
						errores+= error + '
';
					}
				}*/
				alertService.showAlert(this.$bvModal, 'warning', 'Advertencia', 'No se completaron correctamente los datos.\nVerifique los errores en el formulario.');
				return;
			}
			let data = {
				idPostoperatorio: this.data.idPostoperatorio,
				fechaAltaPostoperatorio: this.data.fechaAltaPostoperatorio,
				idInternacionPostoperatorio: this.data.idInternacionPostoperatorio,
				idTipoComplicacionPostoperatorio: this.data.idTipoComplicacionPostoperatorio,
				idComplicacionPostoperatorio: this.data.idComplicacionPostoperatorio,
				tratamientoExtraPostoperatorio: this.data.tratamientoExtraPostoperatorio,
				detalleTratExtraPostoperatorio: this.data.detalleTratExtraPostoperatorio,
				col1Postoperatorio: this.data.col1Postoperatorio,
				col2Postoperatorio: this.data.col2Postoperatorio,
				col3Postoperatorio: this.data.col3Postoperatorio,
			}; 
			this.submited = true;
			postoperatorioService.save(data).then(function(response) {
				_this.submited = false; 
				if(response.body && response.body.status == 'success') {
					alertService.showSuccessToast('Datos guardados con exito.'); 
					//_this.cancelar();
					_this.getData();
				} else {
					if(response.body && response.body.status == 'warning' && response.body.id > 0) {
						alertService.showAlert(_this.$bvModal, 'warning', 'Advertencia', response.body.message);
						_this.data.idPostoperatorio = response.body.id;
						_this.getData();
						return;
					}
				}
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		validar: function() {
			let validaciones = {};
			let errores = false;
			if (typeof this.data.fechaAltaPostoperatorio == 'undefined' || this.data.fechaAltaPostoperatorio == '') {
				errores = true;
				validaciones['fechaAltaPostoperatorio'] = {errores: ['El Fecha es obligatoria.'], estado: false};
			}
			if (typeof this.data.idInternacionPostoperatorio == 'undefined' || this.data.idInternacionPostoperatorio == '') {
				if (typeof this.internacion != 'undefined' && this.internacion != null && typeof this.internacion.idInternacion != 'undefined' && 
					this.internacion.idInternacion != ''  && this.internacion.idInternacion != null) {
					_this.data.idInternacionPostoperatorio = _this.internacion.idInternacion;
				} else {
					_this.cancelar();
				}
			}
			if (typeof this.data.idInternacionPostoperatorio == 'undefined' || this.data.idInternacionPostoperatorio == '') {
				errores = true;
				validaciones['idInternacionPostoperatorio'] = {errores: ['La internacion es obligatoria.'], estado: false};
			}
			if (typeof this.data.tratamientoExtraPostoperatorio == 'undefined' || this.data.tratamientoExtraPostoperatorio === '') {
				errores = true;
				validaciones['tratamientoExtraPostoperatorio'] = {errores: ['El Tratamiento Extra es obligatorio.'], estado: false};
			}
			this.validaciones = validaciones;
			return errores;
		},
		getDiagnosticos: function() {
			_this.diagnosticos = [{idDatoParametrico:"", descripcionDatoParametrico:"Diagnostico"}];
			datosParametricosService.getDiagnosticos({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							value.descripcionDatoParametrico =  value.col1DatoParametrico + " - " + value.descripcionDatoParametrico;
							_this.diagnosticos.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getCondicionesAlta: function() {
			_this.condicionesAlta = [{idDatoParametrico:"", descripcionDatoParametrico:"Condicion Alta"}];
			datosParametricosService.getCondicionesAlta({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							_this.condicionesAlta.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTipoComplicaciones: function() {
			_this.tipoComplicaciones = [];
			datosParametricosService.getTipoComplicaciones({}).then(function(response) {		
				_this.searchComplicaciones = false;			
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							_this.tipoComplicaciones.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getComplicacionesPop: function() {
			_this.complicaciones = [];
			datosParametricosService.getComplicacionesPop({}).then(function(response) {		
				_this.searchComplicaciones = false;			
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							_this.complicaciones.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		limpiarError: function (campo) {
			if (campo == undefined || campo.errores.length == 0) {
				return true;
			}
			campo.errores.length = 0;
			campo.estado = true;
		},
		cancelar: function() {
			routeService.goTo('internaciones'); 
		},
		async desactivar(item) {
			try {
				if(!loginService.hasPermission("eliminar", "postoperatorios")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea desactivar el registro id: ' + item.idPostoperatorio + '?');
				if(conf) {
					_this.submited = true;
					postoperatorioService.remove({id: item.idPostoperatorio}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							_this.getData();
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro eliminado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		},
		editar: function (item) {
			_this.modificando = true;
			_this.data = {
				idPostoperatorio: item.idPostoperatorio,
				idComplicacionPostoperatorio: item.idComplicacionPostoperatorio,
				idTipoComplicacionPostoperatorio: item.idTipoComplicacionPostoperatorio,
				fechaAltaPostoperatorio: item.fechaAltaPostoperatorio,
				idInternacionPostoperatorio: item.idInternacionPostoperatorio,
				tratamientoExtraPostoperatorio: item.tratamientoExtraPostoperatorio,
				detalleTratExtraPostoperatorio: item.detalleTratExtraPostoperatorio,
				col1Postoperatorio: item.col1Postoperatorio,
				col2Postoperatorio: item.col2Postoperatorio,
				col3Postoperatorio: item.col3Postoperatorio,
			};
		},
		nuevaComplicacion() {
			_this.modificando = true;
			_this.data = {
				idInternacionPostoperatorio: _this.data.idInternacionPostoperatorio,				
				tratamientoExtraPostoperatorio: 0,
				fechaAltaPostoperatorio: new Date().toISOString().split('T')[0]
			};
		}
	}
}

